import React from "react";
import { Grid, GridProps } from "@mui/material";
import "./styles.scss";

const classNameBase = "scd-grid";

const GridMainLayout = ({
  children,
  ...props
}: GridProps): React.JSX.Element => {
  return (
    <Grid
      container
      className={`${classNameBase}-wrapper ${classNameBase}-container`}
      {...props}
    >
      {children}
    </Grid>
  );
};

export default GridMainLayout;
